import {
  AgentDirectUnlinkRequest,
  AgentDirectUnlinkResponse
} from '@tryiris-ai/common.protojs/api/v1/agent_direct';
import { AgentRegistryUnlink } from '@tryiris-ai/mailroom-helper/agentRegistry';
import type { UnlinkCloud, UnlinkDirect } from './types.js';
import { toIdFromHex, wrapApiCall } from '#~/api/index.js';
import { StudioError } from '#~/error/index.js';
import { nats } from '#~/nats/index.js';

/**
 * Unlink the specified agent.
 *
 * @param agentId - The ID of the agent to be unlinked.
 * @param token - The token to be used for authentication.
 */
export const unlinkCloud: UnlinkCloud = async (agentId, token) => {
  try {
    await wrapApiCall(async () =>
      AgentRegistryUnlink.request(nats.cloudConnection(), {
        id: toIdFromHex(agentId)!,
        token
      })
    );
  } catch (cause) {
    throw new StudioError(`Unable to unlink agent: ${agentId}`, { cause });
  }
};

/**
 * Unlink the specified agent.
 *
 * @param agentId - The ID of the agent to be unlinked.
 */
export const unlinkDirect: UnlinkDirect = async (agentId) => {
  try {
    await wrapApiCall(async () => {
      const response = await nats.agentConnection(agentId).request(
        `direct.authenticated.${agentId}.unlink.request`,
        AgentDirectUnlinkRequest.encode({
          $type: 'api.v1.AgentDirectUnlinkRequest'
        }).finish(),
        {
          timeout: 15e3
        }
      );

      return AgentDirectUnlinkResponse.decode(response.data);
    });
  } catch (cause) {
    throw new StudioError(`Unable to unlink agent: ${agentId}`, { cause });
  }
};
